import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoadingStatus } from '../../shared/enums/loading';

@Component({
  selector: 'anihis-forgot-password-confirm',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './forgot-password-confirm.component.html',
  styleUrl: './forgot-password-confirm.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForgotPasswordConfirmComponent implements OnInit {
  private route = inject(ActivatedRoute);

  readonly status = LoadingStatus;

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const userId = params['userId'] ?? '';
      const token = params['token'] ?? '';
      const role = (params['role'] ?? '').toLowerCase();

      const query = `?userId=${encodeURIComponent(userId)}&token=${encodeURIComponent(token)}`;

      if (role === 'owner') {
        window.location.href = `com.anihis.app://reset-pass${query}`;
      } else if (role === 'veterinarian') {
        window.location.href = `com.anihis.veterinarian.app://reset-pass${query}`;
      } else {
        window.location.href = `/change-password${query}`;
      }
    });
  }
}
